import "./style.css";
import React, { useState, useEffect } from "react";
import { animated, useSpring, easings } from "@react-spring/three";
import ReactDOM from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import Experience from "./Experience.jsx";
import { Leva } from "leva";
import { Loader, PerspectiveCamera } from "@react-three/drei";
import { Bloom, EffectComposer } from "@react-three/postprocessing";
import { Perf } from "r3f-perf";

function App() {
  const CameraRig = animated(PerspectiveCamera);

  // Set up the animation
  const [animationActive, setAnimationActive] = useState(false);
  const [elementsVisible, setElementsVisible] = useState(true);
  const [cameraAnimationsEnabled, setCameraAnimationsEnabled] = useState(true);

  const [springProps, setAnimationProps] = useSpring(() => ({
    from: { position: [0, 0, 45] },
  }));

  useEffect(() => {
    if (animationActive) {
      // Start the animation when it's active
      setAnimationProps({
        from: { position: [0, 0, 45] },
        to: { position: [0, 0, 0] },
        config: {
          mass: 100,
          friction: 180,
          duration: 1000,
          tension: 30,
          easing: easings.easeInQuad,
        },
      });
    }
  }, [animationActive]);

  const toggleAnimation = () => {
    setElementsVisible(false);
    setTimeout(() => {
      setCameraAnimationsEnabled(false);
      setAnimationActive(!animationActive);
    }, 500);
  };

  return (
    <>
      <Leva hidden />
      <Canvas dpr={[2, 2]} gl={{ antialias: false }} style={{ background: "#051426" }}>
        {/* <Perf position="top-left" /> */}
        <CameraRig makeDefault position={animationActive ? springProps.position : [0, 0, 45]} fov={30} near={1} far={250} />
        <EffectComposer>
          <Experience toggleAnimation={toggleAnimation} elementsVisible={elementsVisible} cameraAnimationsEnabled={cameraAnimationsEnabled} />
          <Bloom mipmapBlur intensity={0.9} luminanceThreshold={0.5} />
        </EffectComposer>
      </Canvas>
      <Loader />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
